import React, { Component } from "react";

import axios from "axios";

import schema from "./schema";
import { DOMAIN } from "config/config";

import Formizo from "Components/LabIZO/Formizo";
import { VStack } from "Components/LabIZO/Stackizo";
import { Accessor, ErrorX, store } from "static";
import { DATA_LINK } from "connectors";

class SysLiveAgent extends Component {
  static propTypes = {};

  static defaultProps = {};

  constructor() {
    super();
    this.state = {
      SettingDoc: undefined,
      RetainMessage: undefined,
    };
  }

  componentDidMount() {
    this._setAllStates(() => {
      this._getSetting();
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (!Accessor.IsIdentical(prevProps, this.props, Object.keys(SysLiveAgent.defaultProps))) {
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState(
      (state, props) => ({
        ...props,
      }),
      callback
    );
  };

  Setting = {
    _onSubmit: async (data) => {
      let SettingLink = "/Config/LiveAgent/Edit";
      let SettingUrl = DOMAIN + SettingLink;
      let SettingPayloadOut = {
        Content: data.SettingDoc,
        JWT: store.user.JWT,
      };

      let RetainLink = "/Tables/Answer/Edit";
      let RetainUrl = DOMAIN + RetainLink;

      data.RetainMessage.text = Object.entries(data.RetainMessage.text).reduce((acc, [key, value]) => {
        acc[key] = typeof value === "string" ? [value] : value;
        return acc;
      }, {});

      let RetainPayloadOut = {
        JWT: store.user.JWT,
        data: {
          ...data.RetainMessage,
        },
      };

      try {
        store.isLoading(true);
        let res = await axios.post(SettingUrl, SettingPayloadOut);
        let resRetain = await axios.post(RetainUrl, RetainPayloadOut);

        store.isLoading(false);

        if (res.data.Success && resRetain.data.Success) {
          this.Setting.onSuccess();
        } else {
          this.Setting.onFail("System message update fails.");
        }
      } catch (e) {
        this.Setting.onFail(ErrorX.Handle(e));
      }
    },

    onSuccess: () => {
      store.Alert("System message updated successfully", "success");
      this._getSetting();
    },

    onFail: (msg) => {
      store.isLoading(false);
      store.Alert(msg, "error");
    },
  };

  _getSetting = async () => {
    let link = "/Config/LiveAgent/Edit";
    let url = DOMAIN + link;

    //Get Retain Message from answer
    let RetainLink = "/Tables/Answer/List";
    let RetainUrl = DOMAIN + RetainLink;

    let payloadOut = {
      JWT: store.user.JWT,
    };

    let RetainPayloadOut = {
      JWT: store.user.JWT,
      data: {},
    };

    try {
      store.isLoading(true);
      let res = await axios.post(url, payloadOut);
      let resRetain = await axios.post(RetainUrl, RetainPayloadOut);
      store.isLoading(false);

      let { Success, payload } = res.data;
      let { Success: RetainSuccess, payload: RetainPayload } = resRetain.data;

      let SettingDoc = {
        SettingDoc: payload,
      };

      if (Success) {
        this.setState({
          SettingDoc: SettingDoc,
        });
      } else {
        store.Alert(payload, "error");
      }

      if (RetainSuccess) {
        let RetainMessage = RetainPayload.docs.filter((doc) => doc._id === "master:FAQ_Other_LiveAgent")[0];
        this.setState({
          RetainMessage: RetainMessage,
        });
      } else {
        store.Alert(RetainPayload, "error");
      }
    } catch (e) {
      ErrorX.Handle(e);
    }
  };

  renderForm() {
    let { SettingDoc, RetainMessage } = this.state;
    if (SettingDoc === undefined || RetainMessage === undefined) return;

    let defaultValue = {
      ...SettingDoc,
      RetainMessage,
    };

    return <Formizo height="100%" schema={schema.LiveAgentSetting} buttons={["Revert", "Submit"]} onSubmit={this.Setting._onSubmit} defaultValue={defaultValue} />;
  }

  render() {
    return <VStack height="100%">{this.renderForm()}</VStack>;
  }
}

export default SysLiveAgent;
